import { ReactNode, useState, useEffect } from "react";
import cn from "classnames";
import { Text, H4, SubTitle1 } from "@components/new/Typo";
import ChevronDownIcon from '@assets/icons/outline/chevron-down.svg?react';
import styles from "./Accordeon.module.scss";

const Accordeon = ({
  className,
  items,
  defaultOpenId,
  stretch,
  onChange,
  hideNumber,
  summaryClassName,
  contentClassName,
}: {
  className?: string;
  summaryClassName?: string;
  contentClassName?: string;
  defaultOpenId?: string;
  onChange?: (id: string) => void;
  items: {
    id: string;
    title: ReactNode;
    subtitle?: ReactNode;
    content: ReactNode;
    disabled?: boolean;
  }[];
  stretch?: boolean;
  hideNumber?: boolean;
}) => {
  const [openId, setOpenId] = useState(defaultOpenId);

  useEffect(() => {
    setOpenId(defaultOpenId);
  }, [defaultOpenId])

  const handleOnClick = (id: string, disabled?: boolean) => {
    if (disabled) return;
    setOpenId(id);
    onChange && onChange(id)
  }

  return (
    <div className={cn(styles.accordeon, className, stretch && styles.stretch)}>
      {items.map((item, idx) => (
        <div
          key={item.id}
          className={cn(
            styles.details,
            item.disabled && styles.disabled,
            item.id === openId ? styles.open : styles.closed,
          )}
          onClick={() => handleOnClick(item.id, item.disabled)}
        >
          <div className={cn(styles.summary, summaryClassName)}>
            <div className={styles.title}>
              {hideNumber ? null : (<SubTitle1 className={styles.index}>{idx + 1}</SubTitle1>)}
              <div className={styles.titleColumn}>
                <H4>{item.title}</H4>
                <Text color="grey-800">{item.subtitle}</Text>
              </div>
            </div>
            <ChevronDownIcon className={styles.chevron} />
          </div>
          <div className={cn(styles.content, (item.id === openId) && contentClassName )}>
            <div className={styles.contentInner}>
              {item.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordeon;
